import { post } from '.';

export function CreateDeviceNotificationEvent(notification = {}) {
	return post<any>("/app/api/device_notification_events", notification);
}